module.exports = __webpack_public_path__ + "static/media/galerija_2021 (11)-min.74e201e9.jpg";